exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cvat-review-workspace.ant-layout{height:100%}.cvat-issue-control{font-size:40px}.cvat-issue-control::after{content:'\\FE56';font-size:32px;position:absolute;bottom:8px;right:-8px}\n", ""]);
